<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" v-if="show.xf" type="primary" @click="handleCreate">任务下发</el-button>
        <el-button size="small" class="btn" v-if="show.bj" type="primary" @click="handleCreate1">任务编辑</el-button>
        <el-button size="small" type="primary" class="btn" v-if="show.sc" @click="handleCreate2">任务删除</el-button>
        <el-button size="small" type="primary" class="btn" v-if="show.dcwbtz" @click="handleCreate3">导出维保计划列表</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item :label="lable.rwlx">
            <el-select v-model="deviceInfo.rwlx" style="width:100%" placeholder="请选择" clearable>
              <el-option v-for="item in optionTasks" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="lable.statue">
            <el-select v-model="deviceInfo.state" filterable clearable :placeholder="'请选择' + lable.statue"
              style="width:120px">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getDeviceinfoClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="deviceData" tooltip-effect="dark"
          style="width: 100%;text-align:center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="任务单号"> </el-table-column>
          <el-table-column prop="rwbt" sortable :label="lable.rwbt" width="120PX">
          </el-table-column>
          <el-table-column prop="rwlx" sortable :label="lable.rwlx" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.rwlx == 1">维保</span>
              <span v-else-if="scope.row.rwlx == 2">检定</span>
              <span v-else-if="scope.row.rwlx == 3">核查</span>
              <span v-else-if="scope.row.rwlx == 4">其他</span>
            </template>
          </el-table-column>
          <el-table-column prop="jhwcsj" sortable :label="lable.jhwcsj" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="xfsj" :label="lable.xfsj" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="wcrq" :label="lable.wcrq" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="zxr" :label="lable.zxr" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zxdw" sortable label="执行单位" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="pj" :label="lable.pj" width="120px" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-rate v-if="scope.row.statue == '3'" v-model="scope.row.pj" style="width:100%" :disabled="true" show-text
                :texts="pj"> </el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="statue" sortable :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == 0" style="color:#4095E5">待执行</span>
              <span v-else-if="scope.row.statue == 1" style="color:cadetblue">待确认</span>
              <span v-else-if="scope.row.statue == 2" style="color:gray">待评价</span>
              <span v-else style="color:blueviolet">评价完成</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="xiangqing(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="deviceData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!------------------------------------------------------------------------------------------------------------------------------>
    <el-dialog :visible.sync="dialogFormVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false" title="任务详情"
      style="width:90% !important;margin-left: 10%;">
      <el-form :model="form" ref="dataForm" label-position="right" size="mini" label-width="100px" style="width: 100%;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务单号">
              <el-input v-model="form.id" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.rwbt">
              <el-input v-model="form.rwbt" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="执行单位">
              <el-input v-model="form.zxdw" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起始日期" prop="qssj">
              <el-input v-model="form.qssj" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="截止日期" prop="jhwcsj">
              <el-input v-model="form.jhwcsj" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="rwlx1" :label="lable.rwlx">
              <el-input v-model="form.rwlx1" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务进度">
              <el-input v-model="form.rwjd" :readonly="true"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="完成质量">
              <el-input v-model="form.wczl" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="人员熟练度">
              <el-input v-model="form.rysld" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行效率">
              <el-input v-model="form.zxxl" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="rwnr" label="任务内容">
              <el-input v-model="form.rwnr" type="textarea" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.pj">
              <el-rate v-model="form.pj" :disabled="true" style="width:100%" :texts="pj" show-text> </el-rate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="设备列表">
          <el-table :data="tableData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="200px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }"
            stripe>
            <el-table-column label="序号" type="index"  show-overflow-tooltip>

            </el-table-column>
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="companyName" label="使用单位" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="执行情况">
          <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" size="mini"
            :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="ZXData" max-height="200px"
            tooltip-effect="dark" style="width: 100%;text-align:center" stripe>
            <el-table-column :label="lable.index" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="taskId" label="任务单号">
            </el-table-column>
            <el-table-column prop="userName" label="执行人">
            </el-table-column>
            <el-table-column prop="zxsj" label="开始时间">
            </el-table-column>
            <el-table-column prop="zxjs" label="结束时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zxqk" label="执行情况" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zxts" :label="lable.zxts" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <div>
          <el-button size="small" type="primary" @click="dialogFormVisible1 = false">确认</el-button>
        </div>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { findAllTask, delTask, selectAllstatus, wbjh, findByModule, findByIdTaskDevice, findByIdZx } from "../../api/api";
export default {
  name: "Task",
  data() {
    return {
      deviceInfo: {
        date: "",
        content: "",
        rwlx: ""
      },
      pj: ["非常差", "差", "一般", "好", "非常好"],

      show: {
        dcwbtz: false,
        sc: false,
        bj: false,
        xf: false
      },
      inform: {},
      tableData: [],
      tableData1: [],
      dialogFormVisible1: false,
      form: {},
      ZXData: [],
      options: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      multipleTable: [],
      deviceData: [],
      optionTasks: [
        {
          id: 1,
          name: "维保"
        },
        {
          id: 2,
          name: "检定"
        },
        {
          id: 3,
          name: "核查"
        },
        {
          id: 4,
          name: "其他"
        }
      ],
      lable: {}
    };
  },
  mounted() {
    this.findLable();
    this.getDeviceinfo();
    this.findAllType();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "116") {
        this.show.dcwbtz = true;
      }
      if (i == "114") {
        this.show.bj = true;
      }
      if (i == "113") {
        this.show.xf = true;
      }
      if (i == "143") {
        this.show.sc = true;
      }
    })
  },
  methods: {
    xiangqing(row) {
      this.form = {};
      this.form = row;
      this.findByIdDevice(row.id);
      for (var i = 0; i < this.optionTasks.length; i++) {
        if (this.optionTasks[i].id == this.form.rwlx) {
          this.form.rwlx1 = this.optionTasks[i].name
        }
      }
      findByIdZx(this.form.id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.ZXData = data;
        }
      });
      this.dialogFormVisible1 = true;
    },
    //根据id查找任务设备信息
    findByIdDevice(row) {
      findByIdTaskDevice(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data;
        }
      });
    },
    handleCreate() {
      sessionStorage.setItem("taskCreate", true)
      let val = {
        path: "/Distribution",
        name: "发布任务"
      }; // debugger //保存数据
      this.$router.push({
        path: "Distribution"
      });
      this.$store.commit("pushtags", val);
    },
    handleCreate3() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 0) {
        var ids = []
        for (var i = 0; i < currentSelect.length; i++) {
          if (currentSelect[i].rwlx == 1) {
            ids.push(currentSelect[i].id)
          }
        }
        if (ids.length > 0) {
          var map = {
            id: ids
          }
          var date = this.timeUtil.timeFormat(new Date())
          wbjh(map).then(datas => {
            const blob = new Blob([datas])
            const dlink = document.createElement('a')
            if ('download' in document.createElement('a')) { // 非IE下载
              const dlink = document.createElement('a')

              dlink.download = "维保计划" + date + ".zip"
              dlink.style.display = 'none'
              dlink.href = URL.createObjectURL(blob)
              document.body.appendChild(dlink)
              dlink.click()
              URL.revokeObjectURL(dlink.href) // 释放URL 对象
              document.body.removeChild(dlink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, "维保计划" + date + ".zip")
            }
          })
        } else {
          this.$message.warning("请选择需要导出的维保计划列表")
        }
      } else if (currentSelect.length < 1) {
        this.$message.warning("请选择需要导出的维保计划列表")
      }
    },
    handleCreate1() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if (currentSelect[0].statue == 0) {
          let val = {
            path: "/taskEditing",
            name: "任务编辑"
          }; // debugger //保存数据
          sessionStorage.setItem("taskUpdate",true)
          sessionStorage.setItem("id", currentSelect[0].id); //添加路由跳转至查看设备
          this.$router.push({
            path: "taskEditing"
          });
          this.$store.commit("pushtags", val);
        } else {
          this.$message.error("任务已开始无法进行修改"); // .....失败信息
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    handleCreate2() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 0) {
        this.$confirm('此操作将永久删除该任务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var arr1 = [];
          for (var i = 0; i < currentSelect.length; i++) {
            arr1.push(currentSelect[i].id)
          }
          delTask(arr1).then(datas => {
            // debugger
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error"
              });
            } else if (status == 200) {
              this.getDeviceinfo();
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: "请求错误",
                type: "error"
              });
            }
          });
        })
      } else {
        this.$message.error("请选择任务"); // .....失败信息
      }
    },
    getDeviceinfoClick(){
      this.pageIndex=1
      this.getDeviceinfo()
    },
    //查找设备信息
    getDeviceinfo() {
      if (sessionStorage.getItem("taskCreate") == "true" || sessionStorage.getItem("taskUpdate") == "true") {
        if (sessionStorage.getItem("taskPageIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("pageIndex") * 1
          if (sessionStorage.getItem("taskCreate") == "true") {
            sessionStorage.setItem("taskCreate", false)
          }
          if (sessionStorage.getItem("taskUpdate") == "true") {
            sessionStorage.setItem("taskUpdate", false)
          }
        }
      }
      var userinfo = JSON.parse(localStorage.getItem("user"))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        state: this.deviceInfo.state,
        rwlx: this.deviceInfo.rwlx,
        userId: userinfo.userId
      };
      findAllTask(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.deviceData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
          this.total = data.length;
          // debugger
        }
      });
    },
    findAllType() {
      selectAllstatus().then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "任务执行") {
              this.options.push({ name: data[i].statusName, id: data[i].statue })
            }
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("taskPageIndex", val)

      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("计划任务").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },

};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/task/Task.vue